export default __webpack_public_path__ + "static/media/roller8.4dc092d6.gif";